import { useEffect, useState } from "react";
import {
  BulkDeleteButton,
  Create,
  Datagrid,
  DeleteButton,
  Edit,
  EditButton,
  FunctionField,
  Labeled,
  LinearProgress,
  List,
  Pagination,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  WrapperField,
} from "react-admin";
import LocalisedDateField from "../components/localisedDateField";
import dataProvider from "../providers/grapheneDataProvider2";

const ProductFilters = [
  <TextInput label="Id" source="tagId__icontains" alwaysOn />,
  <TextInput label="Name" source="name__icontains" alwaysOn />,
  <TextInput label="Category" source="category__icontains" alwaysOn />,
  <TextInput label="Description" source="description__icontains" alwaysOn />,
];

export const ProductTagsList = () => (
  <List
    filter={{ active: true }}
    filters={ProductFilters}
    sort={{ field: "tagId", order: "DESC" }}
    pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100, 500, 1000]} />}
  >
    <Datagrid bulkActionButtons={<BulkDeleteButton mutationMode="pessimistic" confirmTitle="Delete Product Tags" />}>
      <TextField source="tagId" sx={{ minWidth: "400px" }} />
      <TextField source="category" />
      <TextField source="name" />
      <TextField source="description" />
      <WrapperField label="Actions">{<EditButton />}</WrapperField>
    </Datagrid>
  </List>
);

type CategoryChoice = { id: string; name: string };

const useProductTagCategories = () => {
  const [choices, setChoices] = useState<CategoryChoice[] | null>(null);

  useEffect(() => {
    if (!choices) {
      dataProvider.getMany("productTagCategories", {}).then(({ data }: { data: CategoryChoice[] }) => {
        const uniqueChoices = data
          .filter((choice) => choice.id !== "")
          .map((choice) => ({ id: choice.id.toUpperCase(), name: choice.name }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setChoices(uniqueChoices);
      });
    }
  }, [choices]);

  return choices;
};

const ProductTagsCreateOrUpdate = () => {
  const choices = useProductTagCategories();

  return (
    <>
      <Labeled label="Tag category">
        {choices ? (
          <SelectInput
            source="category"
            choices={choices}
            optionValue="id"
            optionText="name"
            fullWidth
          />
        ) : (
          <LinearProgress />
        )}
      </Labeled>
      <Labeled label="Description">
        <TextInput source="description" fullWidth validate={required()} />
      </Labeled>
      <FunctionField
        render={(record: any) => {
          if (record.createdAt) {
            return (
              <Labeled label="Created ">
                <LocalisedDateField record={record} field="createdAt" />
              </Labeled>
            );
          }
        }}
      />
      <FunctionField
        render={(record: any) => {
          if (record.updatedAt) {
            return (
              <Labeled label="Updated ">
                <LocalisedDateField record={record} field="updatedAt" />
              </Labeled>
            );
          }
        }}
      />
    </>
  );
};
const DeleteWithConfirmationToolbar = (
  <Toolbar sx={{ justifyContent: "space-between" }}>
    <SaveButton label="Update" />
    <DeleteButton label="Delete" sx={{ textAlign: "right" }} mutationMode="pessimistic" confirmTitle="Delete Tag" />
  </Toolbar>
);
export const ProductTagsEdit = () => (
  <Edit>
    <SimpleForm toolbar={DeleteWithConfirmationToolbar}>
      <Labeled label="Tag name">
        <TextField source="name" />
      </Labeled>
      <ProductTagsCreateOrUpdate />
    </SimpleForm>
  </Edit>
);

export const ProductTagsCreate = () => (
  <Create>
    <SimpleForm>
      <Labeled label="Tag name">
        <TextInput source="name" />
      </Labeled>
      <ProductTagsCreateOrUpdate />
    </SimpleForm>
  </Create>
);
